import SecteurModel from "../models/SecteurModel"; // modèle simple {id, nom}

export const base_url = "http://localhost:8000/api/v1/";

export async function getBatiment(token) {
    if (!token) throw new Error("Utilisateur non authentifié");

    try {
        const response = await fetch(`${base_url}secteurs/batiment`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) throw new Error("Erreur lors de la récupération des secteurs bâtiment");

        const data = await response.json();
        // Retourne un tableau de modèles SecteurModel
        return data.secteurs_batiment.map((s) => new SecteurModel(s));
    } catch (err) {
        console.error("Erreur getBatiment:", err);
        return [];
    }
}

export async function getAutres(token) {
    if (!token) throw new Error("Utilisateur non authentifié");

    try {
        const response = await fetch(`${base_url}secteurs/autres`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) throw new Error("Erreur lors de la récupération des secteurs autres");

        const data = await response.json();
        return data.secteurs_autres.map((s) => new SecteurModel(s));
    } catch (err) {
        console.error("Erreur getAutres:", err);
        return [];
    }
}
